// extracted by mini-css-extract-plugin
export default {"divider":"AvatarPickerSidebar_divider__-TLpd"};